import React from "react";

const CartFlexed = ({ children }) => {
  return (
    <div className="block md:flex md:justify-center md:gap-5 xl:gap-3 p-4 xl:p-0">
      {children}
    </div>
  );
};

export default CartFlexed;
